export default __webpack_public_path__ + "static/media/notification_green_icon.b4c1ec76.svg";